<script>
  import { _ } from 'svelte-i18n'
	import { createEventDispatcher } from "svelte"
  import Insert from '../../../elements/Insert.svelte'
  import Button from '../../../elements/Button.svelte'
  import { handleUpsell } from '../../../modules/helpers'

  export let feature
  export let alternative = 0
  
  const dispatch = createEventDispatcher()

</script>

<Insert insert_position="before_previews">
  <span slot="toptitle">
    {@html $_('inserts.' + feature + '.topTitle') }
  </span>
  <span slot="title">
    {@html $_('inserts.' + feature + '.titleBefore' + alternative) }
  </span>
  <span slot="text">
    {@html $_('inserts.' + feature + '.textBefore' + alternative) }
  </span>
  <span slot="button">
    <Button kind="accent" on:click={()=> handleUpsell(feature)}>{$_('buttons.upgrade')}</Button>
  </span>
</Insert> 